var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPuertaCerrada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.38 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}.cls-2{fill:#ff4dcd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-puerta-cerrada") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_33",
    "data-name": 33
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.08,97.67a11.67,11.67,0,0,1,11.66,11.67V230.82a11.68,11.68,0,0,1-11.66,11.67H24.3a11.68,11.68,0,0,1-11.67-11.67V109.34A11.68,11.68,0,0,1,24.3,97.67H170.08M97.19,0A60.76,60.76,0,0,0,36.45,60.74V85H24.3A24.36,24.36,0,0,0,0,109.34V230.82a24.37,24.37,0,0,0,24.3,24.3H170.08a24.38,24.38,0,0,0,24.3-24.3V109.34A24.37,24.37,0,0,0,170.08,85H157.93V60.74A60.76,60.76,0,0,0,97.19,0ZM59.53,85V60.74a37.66,37.66,0,1,1,75.32,0V85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.19,143.69a26.39,26.39,0,1,0,26.39,26.39A26.42,26.42,0,0,0,97.19,143.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPuertaCerrada);
export default __webpack_public_path__ + "static/media/ic-puerta-cerrada.8d4d70649e9c025047b679a55f4cb2a7.svg";
export { ForwardRef as ReactComponent };